import { useMemo } from "react"
import { SelectedTypedInstrument } from "helpers/types/instruments/selected"
import {
  getOptimizationPositionSet,
  type OptimizationExperimentSource,
  type OptimizationSourceKind,
} from "../helpers/get-optimization-position-set"

export function useOptimizationPositionSet(
  instrument: SelectedTypedInstrument | null,
  optimizationSourceKind: OptimizationSourceKind,
  optimizationExperimentSource: OptimizationExperimentSource | null,
): SelectedTypedInstrument | null {
  return useMemo(
    () => getOptimizationPositionSet(instrument, optimizationSourceKind, optimizationExperimentSource),
    [instrument, optimizationSourceKind, optimizationExperimentSource],
  )
}
